import { Button, CloseSVG } from "@newsela/angelou";
import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";

import { TopicsDataQASelector } from "../../Topics.constants";
import {
  closeButtonCss,
  headerTitleCss,
  modalHeaderCss,
} from "./TaxonomyModalHeader.styles";

interface ITaxonomyModalHeader {
  setActive: (activeState: boolean) => void;
}

const ButtonWithTrackEvent = withTrackEvent(Button);

export const TaxonomyModalHeader = ({ setActive }: ITaxonomyModalHeader) => {
  return (
    <div css={modalHeaderCss}>
      <h1 css={headerTitleCss} id="modal_title">
        Add topic to filters
      </h1>
      {/* @ts-expect-error Property 'children' does not exist on type */}
      <ButtonWithTrackEvent
        objectType={objectTypes.user}
        actionName={actionNames.update}
        streamProperties={{
          component_type: "TaxonomyCloseModalButton",
          description: "Close Taxonomy Modal",
        }}
        __cssFor={{ root: closeButtonCss }}
        flavor={Button.flavors.incognito}
        ariaProps={{
          "aria-label": "Close Modal Button",
        }}
        icon={{ SvgComponent: CloseSVG }}
        onClick={() => setActive(false)}
        dataProps={{
          "data-qa-selector": TopicsDataQASelector.CLOSE_MODAL,
          "data-testid": "close-modal-button",
        }}
      />
    </div>
  );
};
